/* global google */

import { loadScript } from '../utils/load-script';

const API_KEY = 'AIzaSyDZW3hvWbjobm6KbErKIgmk6yT__QxzZok';
const SCRIPT_URL = 'https://maps.googleapis.com/maps/api/js';

let callbacks = [];
let isLoading = false;

export function init() {
	let elements = Array.from(document.querySelectorAll('.js-google-map'));

	elements.forEach(element => defer(() => {
		let lat = parseFloat(element.dataset.lat);
		let lng = parseFloat(element.dataset.lng);

		let map = createMap(element, {
			center: { lat, lng },
		});

		createMarker(map, lat, lng, {
			url: element.dataset.markerUrl,
		});
	}));
}

function createMap(canvas, options) {
	if (!(canvas instanceof HTMLElement)) {
		return false;
	}

	let defaults = {
		disableDefaultUI: true,
		mapTypeControl: false,
		zoom: 10,
		zoomControl: true,
	};

	return new google.maps.Map(canvas, { ...defaults, ...options });
}

function defer(callback) {
	let url = `${SCRIPT_URL}?key=${API_KEY}`;

	if (isGoogleMapsLoaded()) {
		return callback();
	}

	callbacks.push(callback);

	if (isLoading) {
		return;
	}

	isLoading = true;

	loadScript(url, function onLoad() {
		isLoading = false;

		for (let i = 0; i < callbacks.length; i++) {
			(callbacks.pop())();
		}
	});
}

function isGoogleMapsLoaded() {
	return typeof google === 'object' && typeof google.maps === 'object';
}

function createMarker(map, lat, lng, options = {}) {
	let { url = '/assets/icons/map-marker.svg' } = options;

	return new google.maps.Marker({
		clickable: false,
		map: map,
		position: { lat, lng },
		icon: {
			url: url,
			size: new google.maps.Size(32, 40),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(16, 40),
			scaledSize: new google.maps.Size(32, 40),
		},
	});
}
